export interface NotificationBarMessageConfig {
  [when: string]: string;
}

export enum NotificationBarType {
  Error,
  Info,
  Success,
  Warning
}

export type CustomerNotificationType =
  | 'order-requirements'
  | 'profile-consults'
  | 'appointment-required-consults';

export type CustomerNotificationActionType = 'open-pay-modal' | 'start-consult' | 'start-verification';

export interface INotification {
  // id: string;
  // notificationType: CustomerNotificationType;
  style: NotificationBarType;
  actionType?: CustomerNotificationActionType;
  message: string;
  actionText?: string;
  icon?: string;
  payload?: any;
}
export interface NotificationBarMessage {
  messages?: NotificationBarMessageConfig;
}
